import { useLayoutEffect } from "react";
import type { BoardRuntimeConfig } from "@/config/boardRuntimeConfig";
import { BOARD_CONFIG } from "@/config/browserBoard";
import { resolveFrontendRouteCanonicalPath } from "@/config/frontendRoute";

/** Keep the canonical link synchronized with the basepath-relative router URL. */
export function useRouteCanonical(
  routePath: string,
  config: BoardRuntimeConfig = BOARD_CONFIG,
  locationOrigin: string = globalThis.location.origin,
): void {
  const canonicalPath = resolveFrontendRouteCanonicalPath(config, routePath);
  const canonicalUrl =
    canonicalPath === null
      ? null
      : new URL(canonicalPath, `${locationOrigin}/`).toString();

  useLayoutEffect(() => {
    let canonical = document.head.querySelector<HTMLLinkElement>(
      'link[rel="canonical"]',
    );
    if (canonicalUrl === null) {
      canonical?.remove();
      return;
    }
    if (canonical === null) {
      const robots = document.head.querySelector<HTMLMetaElement>(
        'meta[name="robots" i]',
      );
      if (/\bnoindex\b/i.test(robots?.content ?? "")) return;
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.append(canonical);
    }
    canonical.href = canonicalUrl;
  }, [canonicalUrl]);
}
